export const clearBase64 = (base64: string) => base64.split('base64,')[1];
